module.exports = __webpack_public_path__ + "img/banner2.b42bf8ba.png";